module.exports = __webpack_public_path__ + "static/media/depositos.9a245465.png";